class BxfSegmentedControlConstants {
    static STRING = {
        BXF_SEGMENTED_CONTROL_FLEX: 'bxf_segmented_control_flex',
        LEFT: 'left',
        RIGHT: 'right',
        MIDDLE: 'middle',
        TRAILING: 'trailing',
        BXF_SEGMENTED_CONTROL: 'bxf-segmented-control',
        BUTTON: 'button',
        CHECKED: 'checked',
        DISABLED: 'disabled',
        ICON: '-icon',
        LABEL_PADDING: 'label-padding',
        FIRST_ELEMENT_CHILD: 'firstElementChild',
        BXF_SEGMENTED_CONTROL_INPUT: 'bxf-segmented-control__input',
        BXF_SEGMENTED_CONTROL_LABEL: 'bxf-segmented-control__label',
    };
}

export { BxfSegmentedControlConstants as B };
